import { prop } from "../../decorators/property";
import { KeyParagraphSentenceModel } from "../../desktop/models/key-paragraph-sentence";
import { backboneModelProperties } from "../../decorators/backbone-properties";

@backboneModelProperties({
    relations : [
        {
            type: Backbone.Many,
            key: "Sentences",
            relatedModel: KeyParagraphSentenceModel
        }
    ], defaults: {
        Sentences: []
    }
})
export class KeyParagraphContentModel extends Backbone.AssociatedModel {

    @prop() public Sentences: Backbone.Collection<KeyParagraphSentenceModel>;
    @prop() public StartsParagraph: boolean;
    @prop() public EndsParagraph: boolean;

    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/key-paragraph-content.ts